import React, { useState } from 'react';
import SEOHead from '../components/SEOHead';
import RelatedServices from '../components/RelatedServices';

// Move font loading outside component to prevent re-execution
if (typeof document !== 'undefined') {
  const existingLink = document.querySelector('link[href*="use.typekit.net"]');
  if (!existingLink) {
    const fontLink = document.createElement('link');
    fontLink.rel = 'stylesheet';
    fontLink.href = 'https://use.typekit.net/mwi3kgs.css';
    document.head.appendChild(fontLink);
  }
}

// Material Icons Component
const MaterialIcon = ({ name, className = "w-6 h-6" }) => {
  const icons = {
    phone: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"/>
      </svg>
    ),
    trending_down: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M16 18l2.29-2.29-4.88-4.88-4 4L2 7.41 3.41 6l6 6 4-4 6.3 6.29L22 12v6z"/>
      </svg>
    ),
    attach_money: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M11.8 10.9c-2.27-.59-3-1.2-3-2.15 0-1.09 1.01-1.85 2.7-1.85 1.78 0 2.44.85 2.5 2.1h2.21c-.07-1.72-1.12-3.3-3.21-3.81V3h-3v2.16c-1.94.42-3.5 1.68-3.5 3.61 0 2.31 1.91 3.46 4.7 4.13 2.5.6 3 1.48 3 2.41 0 .69-.49 1.79-2.7 1.79-2.06 0-2.87-.92-2.98-2.1h-2.2c.12 2.19 1.76 3.42 3.68 3.83V21h3v-2.15c1.95-.37 3.5-1.5 3.5-3.55 0-2.84-2.43-3.81-4.7-4.4z"/>
      </svg>
    ),
    calculate: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 17H7v-2h2v2zm4 0h-2v-2h2v2zm4 0h-2v-2h2v2zm-8-4H7v-2h2v2zm4 0h-2v-2h2v2zm4 0h-2v-2h2v2zm-8-4H7V7h2v2zm4 0h-2V7h2v2zm4 0h-2V7h2v2z"/>
      </svg>
    ),
    warning: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"/>
      </svg>
    ),
    trending_up: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M16 6l2.29 2.29-4.88 4.88-4-4L2 16.59 3.41 18l6-6 4 4 6.3-6.29L22 12V6z"/>
      </svg>
    ),
    phone_missed: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M23.71 16.67C20.66 13.78 16.54 12 12 12 7.46 12 3.34 13.78.29 16.67c-.18.18-.29.43-.29.71 0 .28.11.53.29.71L3 20.5c.18.18.43.29.71.29.27 0 .52-.11.7-.28.79-.74 1.69-1.36 2.66-1.85.33-.16.53-.5.53-.87v-2.4c2.01-.3 4.16-.3 6.18 0v2.4c0 .37.2.71.53.87.97.49 1.87 1.12 2.66 1.85.18.17.43.28.7.28.28 0 .53-.11.71-.29l2.71-2.41c.18-.18.29-.43.29-.71 0-.28-.11-.53-.29-.71z"/>
        <path d="M19.41 7.41L15.83 11l3.59 3.59-1.42 1.42L14.41 12.42 10.83 16l3.59 3.59L12.41 17l-3.58 3.58L7.41 19.17 11 15.58 7.41 12l1.42-1.42L12.41 14.17 16 10.58 12.41 7 14.83 4.59l3.58 3.58z"/>
      </svg>
    ),
    close: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
      </svg>
    ),
    checkCircle: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.58L19 8l-9 9z"/>
      </svg>
    )
  };

  return icons[name] || null;
};

const MissedCallsCostCalculator = () => {
  const [showWaitlistModal, setShowWaitlistModal] = useState(false);
  
  // Calculator inputs
  const [inputs, setInputs] = useState({
    dailyCalls: 10,
    averageValue: 150,
    conversionRate: 20,
    missedCallRate: 30
  });

  // Waitlist state
  const [waitlistData, setWaitlistData] = useState({
    name: '',
    email: '',
    phone: '',
    business: 'business owner'
  });
  const [waitlistLoading, setWaitlistLoading] = useState(false);
  const [waitlistSuccess, setWaitlistSuccess] = useState(false);

  const goToLogin = () => {
    window.location.href = '/login';
  };

  // Calculate costs
  const calculations = {
    dailyMissedCalls: Math.round((inputs.dailyCalls * inputs.missedCallRate) / 100),
    get monthlyMissedCalls() {
      return this.dailyMissedCalls * 30;
    },
    get yearlyMissedCalls() {
      return this.dailyMissedCalls * 365;
    },
    get potentialCustomers() {
      return Math.round((this.monthlyMissedCalls * inputs.conversionRate) / 100);
    },
    get monthlyLostRevenue() {
      return this.potentialCustomers * inputs.averageValue;
    },
    get yearlyLostRevenue() {
      return this.monthlyLostRevenue * 12;
    },
    get aiSavings() {
      return this.yearlyLostRevenue - (399 * 12);
    }
  };

  const handleWaitlistSubmit = async () => {
    if (!waitlistData.name || !waitlistData.email || !waitlistData.phone) {
      alert('Please fill in all fields');
      return;
    }
    
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(waitlistData.email)) {
      alert('Please enter a valid email address');
      return;
    }
    
    setWaitlistLoading(true);
    
    try {
      const BACKEND_URL = process.env.NEXT_PUBLIC_BACKEND_URL || 'https://sayhi-voice-engine-production.up.railway.app';
      
      const response = await fetch(`${BACKEND_URL}/api/dashboard/waitlist`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          name: waitlistData.name.trim(),
          email: waitlistData.email.toLowerCase().trim(),
          phone: waitlistData.phone.trim(),
          trade_business: waitlistData.business
        })
      });
  
      const data = await response.json();
  
      if (!response.ok) {
        throw new Error(data.error || `HTTP error! status: ${response.status}`);
      }
  
      if (data.success) {
        setWaitlistSuccess(true);
        setTimeout(() => {
          setShowWaitlistModal(false);
          setWaitlistSuccess(false);
          setWaitlistData({ name: '', email: '', phone: '', business: 'business owner' });
        }, 2000);
      } else {
        throw new Error(data.error || 'Submission failed');
      }
      
    } catch (error) {
      console.error('❌ Waitlist submission error:', error);
      
      if (error.message.includes('already on the waitlist')) {
        alert('This email is already on our waitlist! We\'ll be in touch soon.');
      } else {
        alert(error.message || 'Failed to join waitlist. Please try again or contact support.');
      }
    } finally {
      setWaitlistLoading(false);
    }
  };
  
  const Modal = ({ isOpen, onClose, title, children }) => {
    if (!isOpen) return null;

    return (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
        <div className="bg-white rounded-2xl max-w-md w-full max-h-[90vh] overflow-y-auto">
          <div className="flex items-center justify-between p-6 border-b border-gray-200">
            <h2 className="text-2xl font-bold text-gray-900">{title}</h2>
            <button onClick={onClose} className="text-gray-400 hover:text-gray-600 transition-colors">
              <MaterialIcon name="close" className="w-6 h-6" />
            </button>
          </div>
          <div className="p-6">{children}</div>
        </div>
      </div>
    );
  };

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(amount);
  };

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "WebApplication",
    "name": "Missed Calls Cost Calculator",
    "description": "Calculate how much revenue you're losing from missed phone calls. See the financial impact and ROI of AI phone answering.",
    "url": "https://receptioneer.ai/missed-calls-cost-calculator",
    "applicationCategory": "BusinessApplication",
    "operatingSystem": "Web Browser",
    "offers": {
      "@type": "Offer",
      "price": "0",
      "priceCurrency": "USD"
    },
    "publisher": {
      "@type": "Organization",
      "name": "Receptioneer.ai",
      "url": "https://receptioneer.ai"
    }
  };

  return (
    <>
      <SEOHead
        title="Missed Calls Cost Calculator - Calculate Lost Revenue from Missed Calls"
        description="Free calculator to see how much revenue you're losing from missed phone calls. Calculate the ROI of AI phone answering for your business."
        keywords="missed calls calculator, lost revenue calculator, phone answering roi, missed call cost, business phone calculator"
        canonical="https://receptioneer.ai/missed-calls-cost-calculator"
        ogTitle="Missed Calls Cost Calculator - See Your Lost Revenue"
        ogDescription="Calculate exactly how much money you're losing from missed phone calls. Free tool shows ROI of professional phone answering."
        ogImage="https://receptioneer.ai/images/og-image.jpg"
        structuredData={structuredData}
      />
      <div className="bg-white text-gray-900" style={{ fontFamily: '"redonda", sans-serif' }}>
        {/* Header */}
        <header className="bg-white border-b border-gray-200 py-3 px-4 sticky top-0 z-40">
          <div className="max-w-6xl mx-auto flex items-center justify-between">
            <div className="text-lg font-black text-blue-900">
              <a href="/">receptioneer.ai</a>
            </div>
            <div className="flex items-center gap-6">
              <a href="tel:+17863845350" className="text-blue-900 hover:text-blue-700 font-semibold text-sm">
                Try Live Demo
              </a>
              <button onClick={goToLogin} className="text-blue-900 hover:text-blue-700 font-semibold text-sm">
                Login
              </button>
            </div>
          </div>
        </header>
        
        {/* Hero Section */}
        <section className="bg-gradient-to-br from-red-900 via-red-800 to-red-700 text-white py-20 px-6">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-4xl lg:text-6xl font-black mb-6 leading-tight">
              Missed Calls
              <br />
              <span className="text-red-200">Cost Calculator</span>
            </h1>
            
            <p className="text-xl text-red-100 mb-12 leading-relaxed max-w-3xl mx-auto">
              Calculate exactly how much revenue you're losing from missed phone calls. See the shocking cost of not having professional phone coverage.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12">
              <a
                href="#calculator"
                className="bg-white text-red-900 hover:bg-red-50 px-8 py-4 rounded-xl font-bold text-lg shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300"
              >
                Calculate My Losses →
              </a>
              
              <a
                href="tel:+17863845350"
                className="flex items-center justify-center gap-3 border-2 border-white text-white hover:bg-white hover:text-red-900 px-6 py-4 rounded-xl font-bold text-lg transition-all duration-300"
              >
                <MaterialIcon name="phone" className="w-5 h-5" />
                Test Our AI Now
              </a>
            </div>
          </div>
        </section>

        {/* Calculator Section */}
        <section id="calculator" className="py-16 px-6 bg-gray-50">
          <div className="max-w-6xl mx-auto">
            <h2 className="text-3xl lg:text-4xl font-black mb-12 text-center text-gray-900">
              Calculate Your <span className="text-red-600">Lost Revenue</span>
            </h2>
            
            <div className="grid lg:grid-cols-2 gap-12">
              {/* Input Form */}
              <div className="bg-white rounded-3xl p-8 shadow-lg">
                <div className="flex items-center gap-3 mb-8">
                  <MaterialIcon name="calculate" className="w-8 h-8 text-blue-600" />
                  <h3 className="text-2xl font-black">Your Business Info</h3>
                </div>
                
                <div className="space-y-6">
                  <div>
                    <label className="block text-sm font-bold text-gray-700 mb-3">
                      Daily Phone Calls Received
                    </label>
                    <div className="relative">
                      <input
                        type="number"
                        value={inputs.dailyCalls}
                        onChange={(e) => setInputs({...inputs, dailyCalls: parseInt(e.target.value) || 0})}
                        className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-lg font-semibold"
                        min="1"
                        max="1000"
                      />
                      <span className="absolute right-4 top-3 text-gray-500">calls/day</span>
                    </div>
                  </div>
                  
                  <div>
                    <label className="block text-sm font-bold text-gray-700 mb-3">
                      Average Customer Value
                    </label>
                    <div className="relative">
                      <span className="absolute left-4 top-3 text-gray-500">$</span>
                      <input
                        type="number"
                        value={inputs.averageValue}
                        onChange={(e) => setInputs({...inputs, averageValue: parseInt(e.target.value) || 0})}
                        className="w-full pl-8 pr-4 py-3 border-2 border-gray-200 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-lg font-semibold"
                        min="1"
                        max="100000"
                      />
                    </div>
                  </div>
                  
                  <div>
                    <label className="block text-sm font-bold text-gray-700 mb-3">
                      Call to Customer Conversion Rate
                    </label>
                    <div className="relative">
                      <input
                        type="number"
                        value={inputs.conversionRate}
                        onChange={(e) => setInputs({...inputs, conversionRate: parseInt(e.target.value) || 0})}
                        className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-lg font-semibold"
                        min="1"
                        max="100"
                      />
                      <span className="absolute right-4 top-3 text-gray-500">%</span>
                    </div>
                  </div>
                  
                  <div>
                    <label className="block text-sm font-bold text-gray-700 mb-3">
                      Missed Call Rate (Industry Average: 27%)
                    </label>
                    <div className="relative">
                      <input
                        type="number"
                        value={inputs.missedCallRate}
                        onChange={(e) => setInputs({...inputs, missedCallRate: parseInt(e.target.value) || 0})}
                        className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-lg font-semibold"
                        min="1"
                        max="100"
                      />
                      <span className="absolute right-4 top-3 text-gray-500">%</span>
                    </div>
                  </div>
                </div>
              </div>

              {/* Results */}
              <div className="space-y-6">
                {/* Lost Revenue */}
                <div className="bg-red-50 border-2 border-red-200 rounded-3xl p-8">
                  <div className="flex items-center gap-3 mb-6">
                    <MaterialIcon name="trending_down" className="w-8 h-8 text-red-600" />
                    <h3 className="text-2xl font-black text-red-900">Your Lost Revenue</h3>
                  </div>
                  
                  <div className="space-y-4">
                    <div className="flex justify-between items-center py-3 border-b border-red-200">
                      <span className="font-semibold text-red-800">Missed Calls/Month:</span>
                      <span className="text-xl font-black text-red-600">{calculations.monthlyMissedCalls}</span>
                    </div>
                    <div className="flex justify-between items-center py-3 border-b border-red-200">
                      <span className="font-semibold text-red-800">Lost Customers/Month:</span>
                      <span className="text-xl font-black text-red-600">{calculations.potentialCustomers}</span>
                    </div>
                    <div className="flex justify-between items-center py-3 border-b border-red-200">
                      <span className="font-semibold text-red-800">Monthly Lost Revenue:</span>
                      <span className="text-xl font-black text-red-600">{formatCurrency(calculations.monthlyLostRevenue)}</span>
                    </div>
                    <div className="flex justify-between items-center py-4 bg-red-100 rounded-xl px-4">
                      <span className="font-bold text-red-900">Yearly Lost Revenue:</span>
                      <span className="text-3xl font-black text-red-600">{formatCurrency(calculations.yearlyLostRevenue)}</span>
                    </div>
                  </div>
                </div>

                {/* AI Solution */}
                <div className="bg-blue-50 border-2 border-blue-200 rounded-3xl p-8">
                  <div className="flex items-center gap-3 mb-6">
                    <MaterialIcon name="trending_up" className="w-8 h-8 text-blue-600" />
                    <h3 className="text-2xl font-black text-blue-900">AI Solution ROI</h3>
                  </div>
                  
                  <div className="space-y-4">
                    <div className="flex justify-between items-center py-3 border-b border-blue-200">
                      <span className="font-semibold text-blue-800">AI Cost/Year:</span>
                      <span className="text-xl font-black text-blue-600">{formatCurrency(399 * 12)}</span>
                    </div>
                    <div className="flex justify-between items-center py-3 border-b border-blue-200">
                      <span className="font-semibold text-blue-800">Recovered Revenue:</span>
                      <span className="text-xl font-black text-blue-600">{formatCurrency(calculations.yearlyLostRevenue)}</span>
                    </div>
                    <div className="flex justify-between items-center py-4 bg-green-100 rounded-xl px-4">
                      <span className="font-bold text-green-800">Net Annual Savings:</span>
                      <span className="text-3xl font-black text-green-600">{formatCurrency(calculations.aiSavings)}</span>
                    </div>
                  </div>
                  
                  <div className="mt-6 p-4 bg-blue-100 rounded-xl">
                    <div className="text-center">
                      <div className="text-sm font-bold text-blue-800">ROI</div>
                      <div className="text-2xl font-black text-blue-600">
                        {calculations.yearlyLostRevenue > 0 ? Math.round((calculations.aiSavings / (399 * 12)) * 100) : 0}%
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Industry Stats */}
        <section className="py-16 px-6 bg-white">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-3xl lg:text-4xl font-black mb-12 text-gray-900">
              Industry <span className="text-red-600">Statistics</span>
            </h2>
            
            <div className="grid md:grid-cols-3 gap-8">
              <div className="bg-red-50 rounded-3xl p-8">
                <div className="text-4xl font-black text-red-600 mb-4">27%</div>
                <div className="text-lg font-bold text-gray-900 mb-2">Average Missed Call Rate</div>
                <div className="text-gray-600">1 in 4 calls go unanswered across all industries</div>
              </div>
              
              <div className="bg-orange-50 rounded-3xl p-8">
                <div className="text-4xl font-black text-orange-600 mb-4">80%</div>
                <div className="text-lg font-bold text-gray-900 mb-2">Don't Call Back</div>
                <div className="text-gray-600">Customers who hang up don't try calling again</div>
              </div>
              
              <div className="bg-yellow-50 rounded-3xl p-8">
                <div className="text-4xl font-black text-yellow-600 mb-4">$62B</div>
                <div className="text-lg font-bold text-gray-900 mb-2">Annual Lost Revenue</div>
                <div className="text-gray-600">Total revenue lost to missed calls in the US</div>
              </div>
            </div>
          </div>
        </section>

        {/* Solution CTA */}
        <section className="py-16 px-6 bg-blue-900 text-white">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-3xl lg:text-4xl font-black mb-8">
              Stop Losing Money Today
            </h2>
            
            <p className="text-xl text-blue-100 mb-12">
              Our AI receptionist answers every call instantly, captures every lead, and never misses a potential customer.
            </p>
            
            <div className="bg-white/10 rounded-3xl p-8 mb-8">
              <div className="grid md:grid-cols-3 gap-6 text-center mb-8">
                <div>
                  <div className="text-3xl font-black mb-2">100%</div>
                  <div className="text-blue-200">Calls Answered</div>
                </div>
                <div>
                  <div className="text-3xl font-black mb-2">24/7</div>
                  <div className="text-blue-200">Available</div>
                </div>
                <div>
                  <div className="text-3xl font-black mb-2">$399</div>
                  <div className="text-blue-200">per month</div>
                </div>
              </div>
              
              <button 
                onClick={() => setShowWaitlistModal(true)}
                className="w-full bg-white text-blue-900 hover:bg-blue-50 py-4 rounded-xl font-bold text-xl shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300"
              >
                Stop Missing Calls →
              </button>
            </div>
            
            <p className="text-blue-200">Ready in 24 hours • Cancel anytime • ROI guaranteed</p>
          </div>
        </section>

        {/* Waitlist Modal */}
        <Modal
          isOpen={showWaitlistModal}
          onClose={() => setShowWaitlistModal(false)}
          title="Stop Missing Calls"
        >
          {waitlistSuccess ? (
            <div className="text-center">
              <MaterialIcon name="checkCircle" className="w-16 h-16 text-green-500 mx-auto mb-4" />
              <h3 className="text-2xl font-bold text-gray-900 mb-2">You're all set!</h3>
              <p className="text-gray-600">Your AI receptionist will be ready within 24 hours of launch.</p>
            </div>
          ) : (
            <div className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Your Name</label>
                <input
                  type="text"
                  required
                  value={waitlistData.name}
                  onChange={(e) => setWaitlistData({...waitlistData, name: e.target.value})}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  placeholder="e.g. Sarah Johnson"
                />
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Business Email</label>
                <input
                  type="email"
                  required
                  value={waitlistData.email}
                  onChange={(e) => setWaitlistData({...waitlistData, email: e.target.value})}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  placeholder="sarah@business.com"
                />
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Business Phone</label>
                <input
                  type="tel"
                  required
                  value={waitlistData.phone}
                  onChange={(e) => setWaitlistData({...waitlistData, phone: e.target.value})}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  placeholder="(555) 123-4567"
                />
              </div>
              
              <button
                onClick={handleWaitlistSubmit}
                disabled={waitlistLoading}
                className="w-full bg-blue-900 hover:bg-blue-800 text-white py-3 px-6 rounded-lg font-bold disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {waitlistLoading ? 'Setting Up Your AI...' : 'Get AI Receptionist'}
              </button>
            </div>
          )}
        </Modal>

        {/* Related Services */}
        <RelatedServices currentService="/missed-calls-cost-calculator" />

        {/* Footer */}
        <footer className="bg-white border-t border-gray-200 py-8 px-6">
          <div className="max-w-4xl mx-auto flex flex-col md:flex-row justify-between items-center gap-4">
            <div className="text-lg font-black text-blue-900">
              <a href="/">receptioneer.ai</a>
            </div>
            <div className="flex gap-6 text-sm text-gray-600">
              <a href="/privacy" className="hover:text-blue-900">Privacy</a>
              <a href="/terms" className="hover:text-blue-900">Terms</a>
              <a href="mailto:support@receptioneer.ai" className="hover:text-blue-900">Support</a>
            </div>
          </div>
        </footer>
      </div>
    </>
  );
};

export default MissedCallsCostCalculator;